<template>
  <div>
    <template>
      <v-btn outlined :color="dialogMeetingSummary ? 'info' : 'white'" x-small class="ma-1 float-left meetingSummaryButton" @click="openMeetingSummary" style="overflow: auto; margin: 2px !important;">
        Summary
      </v-btn>
    </template>
    <v-dialog v-model="dialogMeetingSummary" class="dialogMeetingSummary" persistent hide-overlay scrollable max-width="59%" transition="none">
      <v-card class="cardMeetingSummary">
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Meeting Summary </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="closeMeetingSummary" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-title style="padding: 5px 24px 5px !important;">
          <v-list class="pa-0" style="margin-right: 20px;">
            <v-list-item class="pa-0">
              <v-menu ref="menuMeetingSummary" v-model="menuMeetingSummary" transition="scale-transition" offset-y min-width="0%" :nudge-right="40">
                <template v-slot:activator="{ on }">
                  <v-text-field class="formattedDate" v-model="formattedDateMeetingSummary" small prepend-icon="mdi-calendar" readonly v-on="on" style="font-size:14px; padding-top: 0px; margin-top: 0px;" hide-details=""></v-text-field>
                </template>
                <v-date-picker v-model="dateMeetingSummary" no-title scrollable actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menuMeetingSummary = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menuMeetingSummary.save(dateMeetingSummary)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-list-item>
          </v-list>
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="normal" x-small class="ma-1" v-bind="attrs" v-on="on" style="overflow: auto; margin: 2px !important;">
                Countries
              </v-btn>
            </template>
            <v-card>
              <v-card-text class="countriesMeetingSummary">
                <Countries :countries="getIsCountrySelectedFilter" :onClick="onCountryClick" />
              </v-card-text>
            </v-card>
          </v-menu>
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="normal" x-small class="ma-1" v-bind="attrs" v-on="on" style="overflow: auto; margin: 2px !important;">
                Codes
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <Codes :codes="getIsCodesSelectedFilter" :onClick="onCodesClick" />
              </v-card-text>
            </v-card>
          </v-menu>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 0px 0px 0px 0px;">
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="blue"
          ></v-progress-linear>
          <table class="meetingSummaryTable">
            <thead>
              <tr>
                <th class="headcol"></th>
                <th v-for="n in 22" :key="n" style="text-align: center;">R{{ n }}</th>
              </tr>
            </thead>
            <tbody v-for="(racesByType, raceType) in sortedMeetingSummary" :key="raceType">
              <tr style="height: 35px !important;">
                <td class="headcol columnRaceType">
                  <img :src="raceTypeImg[raceType]" style="max-width:100%; margin-right: 10px;" />
                  <strong class="raceType">{{ raceType }}</strong>
                </td>
                <td v-for="n in 22" :key="n"></td>
              </tr>
              <tr v-for="(races, raceName) in racesByType" :key="raceName">
                <td class="headcol" style="vertical-align: bottom;">
                  <v-row>
                    <country-flag :country="races[0].countryGBS" size="small" style="margin-right: -20px; margin: -21px;" /> {{ raceName }}
                  </v-row>
                </td>
                <td v-for="(race, key) in races" :key="key" style="text-align: center; vertical-align: bottom;">
                  <v-tooltip bottom color="black" open-delay="400">
                    <template v-slot:activator="{ on }">
                      <span style="text-align: center; cursor:pointer;" @click="clickRace(race)" v-on="on">{{ race.startTime }}</span>
                    </template>
                    <span class="tooltiptextRaceNavigation caption"><pre class="tooltipTextRaceNavigationPreformatted">Race {{ race.raceNumber }} - {{ race.raceName }}</pre></span>
                  </v-tooltip>
                </td>
                <td v-for="n in (races.length < 22 ? 22 - races.length : races.length)" :key="'race'+n"></td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { format, parseISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import Countries from './filters/Countries'
import Codes from './filters/Codes'

export default {
  name: 'MeetingSummary',
  components: {
    Countries,
    Codes
  },
  props: {
    meetingSummaryToggle: Boolean,
    closeSummary: Function,
    closeMeetingSummaryModal: Boolean
  },
  data: () => ({
    menuMeetingSummary: false,
    raceTypeImg: {
      HARNESS: '/img/race_types/DO_RaceType_Harness-BLACK.svg',
      GREYHOUND: '/img/race_types/DO_RaceType_Greyhounds-BLACK.svg',
      THOROUGHBRED: '/img/race_types/DO_RaceType_Gallops-BLACK.svg'
    },
    dialogMeetingSummary: false,
    isEditing: false,
    isLoading: true
  }),
  computed: {
    ...mapState(['races', 'selectedDateMeetingSummary']),
    ...mapGetters(['getRaces', 'getIsCountrySelectedFilter', 'getIsCodesSelectedFilter', 'getMeetingSummaryRaces', 'getAllMeetingSummaryRaces', 'getAllMeetingSummaryMeetings']),
    dateMeetingSummary: {
      get () {
        const d = format(this.selectedDateMeetingSummary, 'yyyy-MM-dd')
        return d
      },
      async set (n) {
        await this.setDateMeetingSummary(utcToZonedTime(new Date(n)))
        this.clearData()
      }
    },
    meetingSumOpen () {
      return this.meetingSummaryToggle
    },
    closeMeetingSummaryFromModal () {
      return this.closeMeetingSummaryModal
    },
    formattedDateMeetingSummary () {
      return format(this.selectedDateMeetingSummary, 'MMM d, yyyy')
    },
    sortedMeetingSummary: function () {
      const races = this.getMeetingSummaryRaces
      const racesByMeetingType = {}
      var racesByName = {}
      for (const key in races) {
        if (!racesByMeetingType[races[key].meeting.type]) {
          racesByMeetingType[races[key].meeting.type] = []
        }

        racesByMeetingType[races[key].meeting.type].push({
          displayName: races[key].meeting.track.name,
          id: races[key].id,
          meeting: {
            ExternalMeetingID: races[key].meeting.externalIDs[0],
            id: races[key].meeting.id
          },
          raceNumber: races[key].number,
          countryGBS: races[key].meeting.track.country,
          meetingType: races[key].meeting.type,
          startTime: format(parseISO(races[key].startTime), 'HH:mm'),
          status: races[key].status,
          raceName: races[key].name
        })
      }

      for (const type in racesByMeetingType) {
        racesByName = {}
        for (const race in racesByMeetingType[type]) {
          const name = racesByMeetingType[type][race].displayName
          if (!racesByName[name]) {
            racesByName[name] = []
          }
          racesByName[name].push(racesByMeetingType[type][race])
        }

        var racesByNameSorted = {}
        Object.keys(racesByName).sort().forEach(function (v) {
          racesByNameSorted[v] = racesByName[v]
        })

        racesByMeetingType[type] = racesByNameSorted
      }

      var racesByMeetingTypeSorted = {}
      Object.keys(racesByMeetingType).sort().reverse().forEach(function (v) {
        racesByMeetingTypeSorted[v] = racesByMeetingType[v]
      })
      if (Object.keys(racesByMeetingTypeSorted).length > 1) {
        this.setLoading()
      }
      return racesByMeetingTypeSorted
    }
  },
  watch: {
    meetingSumOpen () {
      if (this.meetingSummaryToggle) {
        this.openMeetingSummary()
        this.dialogMeetingSummary = true
      }
    },
    closeMeetingSummaryFromModal () {
      if (this.closeMeetingSummaryModal) {
        this.$modal.hide('ms-unsaved-modal')
        this.dialogMeetingSummary = false
        this.closeSummary()
      }
    }
  },
  methods: {
    ...mapActions(['setDateMeetingSummary', 'updateRaceNavFilter', 'setDateMeetingSummary', 'selectRace', 'setCustomData', 'selectRaceNav', 'fetchMeetingSummaryRaces']),
    setLoading () {
      this.isLoading = false
    },
    onCountryClick (countries) {
      this.updateRaceNavFilter({ filter: 'countries', value: countries })
    },
    onCodesClick (codes) {
      this.updateRaceNavFilter({ filter: 'codes', value: codes })
    },
    openMeetingSummary () {
      this.dialogMeetingSummary = true
    },
    closeMeetingSummary () {
      if (this.isEditing) {
        this.$modal.show('ms-unsaved-modal')
        return
      }
      this.dialogMeetingSummary = false
      this.closeSummary()
    },
    clickRace (v) {
      this.dialogMeetingSummary = false
      this.selectRaceNav(1)
      this.selectRace({
        id: v.id,
        idChanged: true
      })
    },
    clearData () {
      this.openMeetingSummary()
    }
  }
}

</script>

<style>
  .meetingSummaryTable {
      border:none;
      border-collapse: collapse;
      width: 1700px;
      overflow: scroll;
  }

  .meetingSummaryTable th {
      background: white;
      position: -webkit-sticky; /* for Safari */
      position: sticky;
      top: 0;
      border-top: none;
      border-left: none;
      border-bottom: 1px solid #e0e0e0;
  }

  .meetingSummaryTable .headcol {
      position: -webkit-sticky; /* for Safari */
      position: sticky;
      left: 0;
      background: #f2f2f2;
      border-left: none;
      padding-left: 20px;
      width: 200px;
  }

  .meetingSummaryTable td, .meetingSummaryTable th {
      border: 0.5px solid #d8d8d8;
      height: 25px !important;
  }

  .titleBar-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  thead th:first-child {
    left: 0;
    z-index: 1;
  }

  .meetingSummaryTable tbody td:nth-of-type(even) {
    background: white !important;
  }

  .countriesMeetingSummary {
    padding: 40px 16px 0px 16px !important;
  }

  .cardMeetingSummary {
    -webkit-touch-callout: none !important; /* iOS Safari */
    -webkit-user-select: none !important;   /* Safari */
    -khtml-user-select: none !important;    /* Konqueror HTML */
    -moz-user-select: none !important;      /* Firefox */
    -ms-user-select: none !important;       /* Internet Explorer/Edge */
    user-select: none !important;           /* Non-prefixed version, currently supported by Chrome and Opera */
  }

  .meetingCheckbox {
    width: 20px;
    margin-top: revert;
    margin-left: auto;
    float: right;
  }

  .meetingRaceHid {
    text-decoration: line-through;
    font-size: 0.9em;
    font-weight: bold;
    color: #333;
  }

  .columnRaceType {
    padding-left: 5px !important;
  }

  .row {
    margin-right: 0px;
  }

  .checkBoxesShowed {
    width: 55px;
  }

</style>
